var _g, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckAndScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 556,
    height: 157,
    viewBox: "0 0 556 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102:15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 74.3V96.1H36.3V84.3C36.3 79.4 39.7 75.3 44.5 74.3Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8 86.7H223.4V98.9H261.8V86.7Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.7 86.7H375.7V99.5H472.7V86.7Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7 9.59999V31.5H154.6V9.59999C154.5 8.19999 155.6 6.99999 157 6.89999C158.4 6.79999 159.6 7.89999 159.7 9.29999C159.7 9.29999 159.7 9.39999 159.7 9.59999Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 30.1V103.2H151.2V30.1C151.2 28.8 152.2 27.8 153.5 27.8H160.6C162 27.8 163 28.8 163 30.1Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.8 101.2H481.4V111.8H485.8C486.8 111.8 487.7 111 487.7 109.9V103.1C487.7 102 486.9 101.2 485.8 101.2Z",
    fill: "#E56353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.8 94.1H369V116.6H482.8V94.1Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1 103.1V109.9C302.1 110.9 301.3 111.8 300.2 111.8H295.8V101.2H300.2C301.3 101.2 302.1 102 302.1 103.1Z",
    fill: "#E56353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5 94.1H140.6V115.6H297.5V94.1Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6 68.5V117.4H41.4V73.8L83 68.5V44.9H80.1C79.1 44.9 78.3 44.1 78.3 43.1V41.1C78.3 40.1 79.1 39.3 80.1 39.3H147.5L147.6 68.5Z",
    fill: "#F7BE56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2 93.5V117.5H32.3C29.9 117.5 28 115.6 28 113.2C28 113.2 28 113.2 28 113.1V97.8C28 95.4 29.9 93.5 32.3 93.5H46.2Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8 105.6C35.8 108.1 33.8 110.2 31.3 110.3V100.8C33.8 100.9 35.8 103 35.8 105.6Z",
    fill: "#27A2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 50V110.3H110.2C110.2 99.9 102 91.4 91.6 90.9L93.4 49.8C93.5 48 94.9 46.6 96.7 46.6H127C128.9 46.7 130.4 48.2 130.4 50Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6 51.4C123.5 50.5 122.7 49.8 121.8 49.8H100.4C99.5 49.8 98.7 50.5 98.6 51.4L96.9 64.1C96.8 65.1 97.5 66 98.5 66.2C98.6 66.2 98.7 66.2 98.8 66.2H123.6C124.6 66.2 125.4 65.4 125.4 64.4C125.4 64.3 125.4 64.2 125.4 64.1L123.6 51.4Z",
    fill: "#27A2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 49.1H81.9C81.2 49.1 80.6 49.6 80.6 50.3L79.4 65.4C79.3 66.1 79.9 66.8 80.6 66.8H80.7H86C86.7 66.8 87.3 66.2 87.3 65.5V50.4C87.3 49.7 86.7 49.1 86 49.1Z",
    fill: "#27A2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1 48.7H135.1C133.8 48.7 132.8 49.7 132.8 51V65C132.8 66.3 133.8 67.3 135.1 67.3H142.1C143.4 67.3 144.4 66.3 144.4 65V51C144.4 49.7 143.4 48.7 142.1 48.7C142.1 48.7 142.2 48.7 142.1 48.7Z",
    fill: "#27A2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 72.5V77.5H115.4V72.5C119 73.9 123 73.9 126.6 72.5Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.2 116.9C430.2 127 438.4 135.3 448.6 135.3C458.8 135.3 467 127.1 467 116.9C467 106.8 458.8 98.5 448.6 98.5C438.5 98.6 430.3 106.8 430.2 116.9Z",
    fill: "#2F4859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.9 116.9C436.9 123.4 442.1 128.6 448.6 128.6C455.1 128.6 460.3 123.4 460.3 116.9C460.3 110.4 455.1 105.2 448.6 105.2C442.1 105.2 436.9 110.4 436.9 116.9Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.9 116.9C436.9 117.8 437 118.7 437.2 119.5C438.8 119.1 440.5 119.7 441.3 121.1C442.1 122.5 441.8 124.3 440.6 125.5C441.9 126.7 443.4 127.6 445.1 128.1C445.5 126.2 447.4 124.9 449.3 125.3C450.7 125.6 451.8 126.7 452.1 128.1C453.8 127.6 455.3 126.7 456.6 125.5C455.4 124.4 455.1 122.6 455.9 121.1C456.8 119.7 458.4 119.1 460 119.5C460.2 118.6 460.4 117.8 460.3 116.9C460.3 116 460.2 115.2 460 114.4C458.1 115 456.1 114 455.5 112.1C455.1 110.8 455.5 109.3 456.5 108.4C455.2 107.2 453.7 106.4 452 105.8C451.6 107.7 449.7 109 447.8 108.6C446.4 108.3 445.3 107.2 445 105.8C443.3 106.3 441.8 107.2 440.5 108.4C441.7 109.5 442 111.3 441.2 112.8C440.3 114.2 438.6 114.8 437 114.4C437 115.1 436.9 116 436.9 116.9Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 116.9C379.5 127 387.7 135.3 397.9 135.3C408.1 135.3 416.3 127.1 416.3 116.9C416.3 106.8 408.1 98.5 397.9 98.5C387.8 98.6 379.6 106.8 379.5 116.9Z",
    fill: "#2F4859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2 116.9C386.2 123.4 391.4 128.6 397.9 128.6C404.4 128.6 409.6 123.4 409.6 116.9C409.6 110.4 404.4 105.2 397.9 105.2C391.4 105.2 386.2 110.4 386.2 116.9Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2 116.9C386.2 117.8 386.3 118.7 386.5 119.5C388.1 119.1 389.8 119.7 390.6 121.1C391.4 122.5 391.1 124.3 389.9 125.5C391.2 126.7 392.7 127.6 394.4 128.1C394.8 126.2 396.7 124.9 398.7 125.4C400.1 125.7 401.2 126.8 401.4 128.1C403.1 127.6 404.6 126.7 405.9 125.5C404.7 124.4 404.4 122.6 405.2 121.1C406.1 119.7 407.7 119 409.3 119.5C409.5 118.6 409.7 117.8 409.6 116.9C409.6 116 409.5 115.2 409.3 114.4C407.4 115 405.4 113.9 404.8 112C404.4 110.7 404.8 109.2 405.8 108.3C404.5 107.1 403 106.3 401.3 105.7C400.9 107.6 399 108.9 397 108.4C395.6 108.1 394.5 107 394.3 105.7C392.6 106.2 391.1 107.1 389.8 108.3C391 109.4 391.3 111.2 390.5 112.7C389.6 114.1 387.9 114.7 386.3 114.3C386.3 115.1 386.2 116 386.2 116.9Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 116.9C247 127 255.2 135.3 265.4 135.3C275.6 135.3 283.8 127.1 283.8 116.9C283.8 106.8 275.6 98.5 265.4 98.5C255.2 98.6 247 106.8 247 116.9Z",
    fill: "#2F4859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.6 116.9C253.6 123.4 258.8 128.6 265.3 128.6C271.8 128.6 277 123.4 277 116.9C277 110.4 271.8 105.2 265.3 105.2C258.8 105.2 253.6 110.4 253.6 116.9Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.6 116.9C253.6 117.8 253.7 118.7 253.9 119.5C255.5 119.1 257.2 119.7 258 121.1C258.8 122.5 258.5 124.3 257.3 125.5C258.6 126.7 260.1 127.6 261.7 128.1C262.1 126.2 264 124.9 266 125.4C267.4 125.7 268.5 126.8 268.7 128.1C270.4 127.6 271.9 126.7 273.2 125.5C272 124.4 271.7 122.6 272.5 121.1C273.4 119.7 275 119 276.6 119.5C276.8 118.6 277 117.8 276.9 116.9C276.9 116 276.8 115.2 276.6 114.4C274.7 115 272.7 114 272.1 112.1C271.7 110.8 272.1 109.3 273.1 108.4C271.8 107.2 270.3 106.4 268.6 105.8C268.2 107.7 266.3 109 264.4 108.6C263 108.3 261.9 107.2 261.6 105.8C259.9 106.3 258.4 107.2 257.1 108.4C258.3 109.5 258.6 111.3 257.8 112.8C256.9 114.2 255.2 114.8 253.6 114.4C253.7 115.1 253.6 116 253.6 116.9Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.3 116.9C196.3 127 204.5 135.3 214.7 135.3C224.9 135.3 233.1 127.1 233.1 116.9C233.1 106.8 224.9 98.5 214.7 98.5C204.5 98.6 196.3 106.8 196.3 116.9Z",
    fill: "#2F4859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 116.9C202.8 123.4 207.9 128.8 214.4 129C220.9 129.2 226.3 124.1 226.5 117.6C226.5 117.4 226.5 117.1 226.5 116.9C226.3 110.4 220.9 105.3 214.4 105.5C208.2 105.7 203.2 110.7 203 116.9Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 116.9C203 117.8 203.1 118.7 203.3 119.5C204.9 119.1 206.6 119.7 207.4 121.1C208.2 122.5 207.9 124.3 206.7 125.5C208 126.7 209.5 127.6 211.1 128.1C211.5 126.2 213.4 124.9 215.4 125.4C216.8 125.7 217.9 126.8 218.1 128.1C219.8 127.6 221.3 126.7 222.5 125.5C221.3 124.4 221 122.6 221.8 121.1C222.7 119.7 224.3 119 225.9 119.5C226.1 118.6 226.2 117.8 226.2 116.9C226.2 116 226.1 115.2 225.9 114.4C224 115 222 113.9 221.4 112C221 110.7 221.4 109.2 222.4 108.3C221.1 107.1 219.6 106.3 218 105.7C217.6 107.6 215.7 108.9 213.7 108.4C212.3 108.1 211.2 107 211 105.7C209.3 106.2 207.8 107.1 206.5 108.3C207.7 109.4 208 111.2 207.2 112.7C206.3 114.1 204.6 114.7 203 114.3C203.1 115.1 203 116 203 116.9Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 116.9C59 127 67.2 135.3 77.4 135.3C87.6 135.3 95.8 127.1 95.8 116.9C95.8 106.8 87.6 98.5 77.4 98.5C67.2 98.6 59 106.8 59 116.9Z",
    fill: "#2F4859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6 116.9C65.6 123.4 70.8 128.6 77.3 128.6C83.8 128.6 89 123.4 89 116.9C89 110.4 83.8 105.2 77.3 105.2C70.8 105.2 65.6 110.4 65.6 116.9Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6 116.9C65.6 117.8 65.7 118.7 66 119.5C67.6 119.1 69.3 119.7 70.1 121.1C70.9 122.5 70.6 124.3 69.4 125.5C70.7 126.7 72.2 127.6 73.9 128.1C74.3 126.2 76.2 124.9 78.2 125.4C79.6 125.7 80.7 126.8 80.9 128.1C82.6 127.6 84.1 126.7 85.4 125.5C84.2 124.4 83.9 122.6 84.7 121.1C85.6 119.7 87.2 119 88.8 119.5C89 118.6 89.1 117.8 89.1 116.9C89.1 116 89 115.2 88.8 114.4C86.9 115 84.9 113.9 84.3 112C83.9 110.7 84.3 109.2 85.3 108.3C84 107.1 82.5 106.3 80.8 105.7C80.4 107.6 78.5 108.9 76.5 108.4C75.1 108.1 74 107 73.8 105.7C72.1 106.2 70.6 107.1 69.3 108.3C70.5 109.4 70.8 111.2 70 112.7C69.1 114.1 67.4 114.7 65.8 114.3C65.7 115.1 65.6 116 65.6 116.9Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4 112.7V121.2C172.4 123.4 170.7 125.1 168.5 125.1H138.5C136.3 125.1 134.6 123.4 134.6 121.2V112.7C134.6 110.5 136.3 108.8 138.5 108.8H168.5C170.7 108.8 172.4 110.5 172.4 112.7Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4 128C142.5 128 141.8 127.3 141.8 126.4V107.5C141.9 106.6 142.7 105.9 143.6 106C144.4 106.1 145 106.7 145.1 107.5V126.4C145.1 127.3 144.4 128 143.4 128Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5 128C152.6 128 151.9 127.3 151.9 126.4V107.5C151.9 106.6 152.6 105.9 153.5 105.9C154.4 105.9 155.1 106.6 155.1 107.5V126.4C155.1 127.3 154.4 128 153.5 128Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.5 128C162.6 128 161.9 127.3 161.9 126.4V107.5C161.9 106.6 162.6 105.9 163.5 105.9C164.4 105.9 165.1 106.6 165.1 107.5V126.4C165.2 127.3 164.4 128 163.5 128Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 9.5C159 10.3 158.2 10.8 157.2 10.8C156.2 10.8 155.4 10.2 155.4 9.5C155.4 8.8 156.2 8.3 157.2 8.3C158.2 8.3 159 8.8 159 9.5Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.4 4.89999H467.2C473.6 4.89999 478.8 9.79999 478.8 15.9V78.9C478.8 85 473.6 89.9 467.2 89.9H195.4C189 89.9 183.8 85 183.8 78.9V15.9C183.8 9.79999 189 4.89999 195.4 4.89999Z",
    stroke: "#64798A",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.4442,
    y: 135,
    width: 451,
    height: 9,
    fill: "#03A2FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 144.776,
    width: 55.7296,
    height: 9,
    transform: "rotate(-10.1034 0 144.776)",
    fill: "#03A2FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 502.044,
    y: 135,
    width: 55.388,
    height: 9,
    transform: "rotate(13.1292 502.044 135)",
    fill: "#03A2FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 144,
    width: 8,
    height: 10,
    fill: "#979797"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465 144H473V154H465V144Z",
    fill: "#979797"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 144,
    width: 8,
    height: 10,
    fill: "#979797"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 144,
    width: 8,
    height: 10,
    fill: "#979797"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102:15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 459.7,
    height: 135.3,
    fill: "white",
    transform: "translate(28)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckAndScale);
export default __webpack_public_path__ + "static/media/TruckAndScale.b4ce6ea99cb2e0f5940f7ddbe34faade.svg";
export { ForwardRef as ReactComponent };